import LoginNonSso from 'pages/LoginPage/LoginNonSso';
import React from 'react';

import { LoginPageResolverEnum } from '../../utils/constants';
import { ILoginPageResolver } from '../types';

const LoginNonSsoResolver = (props: {
  loginPageHandler: ({
    strategy,
    username,
  }: {
    strategy: LoginPageResolverEnum;
    username: string;
  }) => void;
  username: string;
}): ILoginPageResolver => {
  return {
    resolve: (loginPageResolverEnum: LoginPageResolverEnum) => {
      return loginPageResolverEnum === LoginPageResolverEnum.LOGIN_NON_SSO;
    },
    reactComponent: () => <LoginNonSso {...props} />,
  };
};

export default LoginNonSsoResolver;
